(function () {
	function docReady(fn) {
		if (document.readyState === 'complete' || document.readyState === 'interactive') {
			setTimeout(fn, 1);
			return;
		}

		document.addEventListener('DOMContentLoaded', fn);
	}

	function setActiveColumn(table, column, selectedTab) {
		if (!table || !column) {
			return;
		}

		table.setAttribute('data-active-column', column);

		table.querySelectorAll('[data-comparison-table-tab]').forEach(function (tab) {
			var isActive = tab === selectedTab || tab.getAttribute('data-column') === column;

			tab.classList.toggle('is-active', isActive);
			tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
			tab.setAttribute('tabindex', isActive ? '0' : '-1');
		});
	}

	function moveTabFocus(tabs, nextIndex) {
		var nextTab = tabs[nextIndex];

		if (!nextTab) {
			return;
		}

		nextTab.focus();
		nextTab.click();
	}

	function initComparisonTables() {
		document.querySelectorAll('[data-comparison-table]').forEach(function (table) {
			var tabs = Array.prototype.slice.call(table.querySelectorAll('[data-comparison-table-tab]'));

			if (!tabs.length) {
				return;
			}

			setActiveColumn(table, tabs[0].getAttribute('data-column'), tabs[0]);

			tabs.forEach(function (tab, index) {
				tab.addEventListener('click', function () {
					setActiveColumn(table, tab.getAttribute('data-column'), tab);
				});

				tab.addEventListener('keydown', function (event) {
					if (event.key === 'ArrowRight') {
						event.preventDefault();
						moveTabFocus(tabs, (index + 1) % tabs.length);
					}

					if (event.key === 'ArrowLeft') {
						event.preventDefault();
						moveTabFocus(tabs, (index - 1 + tabs.length) % tabs.length);
					}

					if (event.key === 'Home') {
						event.preventDefault();
						moveTabFocus(tabs, 0);
					}

					if (event.key === 'End') {
						event.preventDefault();
						moveTabFocus(tabs, tabs.length - 1);
					}
				});
			});
		});
	}

	docReady(initComparisonTables);
})();
